import { api } from "@/lib/api";
import { hc } from "@/lib/heycatch";

const HC_EVENT = { view: "phone_bar_viewed", tap: "phone_bar_tapped", try_start: "phone_bar_started_chapter_one" };

const SID_KEY = "umbra_bar_sid";
export const BAR_TAPPED_KEY = "umbra_bar_tapped";

function sid() {
  try {
    let s = window.sessionStorage.getItem(SID_KEY);
    if (!s) {
      s = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
      window.sessionStorage.setItem(SID_KEY, s);
    }
    return s;
  } catch {
    return null;
  }
}

export function trackBar(type, page = "home") {
  const s = sid();
  if (s) api.post("/events/mobile-bar", { type, page, sid: s }).catch(() => {});
  hc("trackEvent", HC_EVENT[type], { page });
}

export function trackTryStartIfFromBar() {
  let page;
  try {
    page = window.sessionStorage.getItem(BAR_TAPPED_KEY);
    if (page !== "home" && page !== "pricing") return;
    window.sessionStorage.setItem(BAR_TAPPED_KEY, "done");
  } catch {
    return;
  }
  trackBar("try_start", page);
}
